export default __webpack_public_path__ + "static/media/help.5bfbcb0a.svg";